import { Box, Text } from '@factorialco/deprecated-design-system'
import moment, { Moment } from 'moment'

import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'

import Details from './Details'

interface Props {
  endDate?: Moment | null
  canEdit: boolean
  isEmployeeTerminated: boolean
}

const EndDate = ({ endDate, canEdit, isEmployeeTerminated }: Props) => {
  const now = moment()
  const isFuture = endDate ? endDate.isAfter(now) : false
  const formattedEndDate = endDate ? i18nDateToString(endDate, 'ui_dmy_long') : null
  const tooltipInformation = isFuture
    ? i18n.t('contract_versions.contract_information.end_date_tooltip_future', {
        endDate: formattedEndDate,
      })
    : i18n.t('contract_versions.contract_information.end_date_tooltip_past', {
        endDate: formattedEndDate,
      })

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s2">
      <Box gap="s8">
        <Box flexDirection="row" alignItems="center" gap="s4" height="s24">
          <Text size="200" weight="normal" color="grey800">
            {i18n.t('contract_versions.contract_information.end_date')}
          </Text>
          {endDate && <ContractTooltip information={tooltipInformation} icon="info-circle-line" />}
        </Box>
        {endDate && (
          <Text size="300" weight="medium" color="grey1000">
            {formattedEndDate}
          </Text>
        )}
        {!endDate && (
          <Text size="300" weight="medium" color="grey600">
            {i18n.t('contract_versions.contract_information.not_informed')}
          </Text>
        )}
      </Box>
      {endDate && (
        <Details endDate={endDate} canEdit={canEdit} isEmployeeTerminated={isEmployeeTerminated} />
      )}
    </Box>
  )
}

export default EndDate
